import Reveal from './Reveal';

/** Consistent section header: eyebrow, h2 and optional lead paragraph. */
const SectionHeading = ({ id, eyebrow, title, lead, align = 'left', className = '' }) => (
  <Reveal className={`${align === 'center' ? 'mx-auto text-center' : ''} max-w-3xl ${className}`}>
    <p className="eyebrow">{eyebrow}</p>
    <h2 id={id} className="section-title mt-3">
      {title}
    </h2>
    {lead && <p className={`section-lead ${align === 'center' ? 'mx-auto' : ''}`}>{lead}</p>}
  </Reveal>
);

export default SectionHeading;
